/**
 * Feature Flags
 *
 * Date-based feature flags allow changes to be deployed ahead of time
 * and become active automatically on the configured UTC activation date.
 *
 * To add a new flag:
 *  1. Define its activation date as a `Date` constant below.
 *  2. Export a named `is<FeatureName>Enabled()` calling `isFeatureEnabled`.
 */

/**
 * Returns true when the current UTC timestamp is on or after `activationDate`.
 */
export const isFeatureEnabled = (activationDate: Date): boolean =>
  // Use Date.now() — a simple number — so Jest can mock it with jest.spyOn(Date, 'now')
  Date.now() >= activationDate.getTime();

// ---------------------------------------------------------------------------
// Flag: M&G Advice Branding
// Switches "M&G Wealth Advice" → "M&G Advice" / "M&G Advice Partners Limited" across all content.
// Activation: 16 October 2025, 09:00 BST (08:00 UTC)
// ---------------------------------------------------------------------------
export const MG_ADVICE_BRANDING_DATE = new Date('2025-10-16T08:00:00.000Z');

export const isMGAdviceBrandingEnabled = (): boolean =>
  isFeatureEnabled(MG_ADVICE_BRANDING_DATE);



// WEBPACK FOOTER //
// ./src/utilities/featureFlags.ts